import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createFundingDetailsApi(params: any) {
    let apiData: any = {
        startDate: params.startDate,
        endDate: params.endDate,
        saveReport: params.saveReport
    }
    
    let backendApiUrl = `${config.BACKEND_BASE_URL}/report/funding-details`
    return api.create(`${backendApiUrl}`, apiData)
}

export { createFundingDetailsApi }